import { EntityTypeId } from "./EntityTypeId.enum"

// sets may be faster after 10-20 items
export const waterEntityTypeIdList = [
  EntityTypeId.Sea,
  EntityTypeId.River,
  EntityTypeId.Lake,
  EntityTypeId.Marsh,
  EntityTypeId.Swamp,
  // Shoals are not water, they are beaches
]
